{
  "actionbar.actions": "Eylemler",
  "actionbar.actionsAvailable": "Eylemler mevcut.",
  "actionbar.clearSelection": "Seçimi temizle",
  "actionbar.selected": "{count, plural, =0 {Hiçbiri seçilmedi} other {# seçildi}}",
  "actionbar.selectedAll": "Tümü seçildi",
  "actionbutton.pending": "beklemede",
  "breadcrumbs.more": "Daha fazla öğe",
  "button.pending": "beklemede",
  "calendar.invalidSelection": "Seçilen {selectedCount, plural, one {tarih} other {tarihler}} müsait değil.",
  "combobox.loading": "Yükleniyor...",
  "combobox.loadingMore": "Daha fazla yükleniyor...",
  "combobox.noResults": "Sonuç yok",
  "contextualhelp.help": "Yardım",
  "contextualhelp.info": "Bilgiler",
  "datepicker.endTime": "Bitiş saati",
  "datepicker.startTime": "Başlangıç saati",
  "datepicker.time": "Saat",
  "dialog.alert": "Uyarı",
  "dialog.dismiss": "Kapat",
  "dropzone.replaceMessage": "Değiştirmek için dosyayı bırakın",
  "inlinealert.informative": "Bilgiler",
  "inlinealert.negative": "Hata",
  "inlinealert.notice": "Uyarı",
  "inlinealert.positive": "Başarılı",
  "label.(optional)": "(isteğe bağlı)",
  "label.(required)": "(gerekli)",
  "listview.loading": "Yükleniyor...",
  "listview.loadingMore": "Daha fazla yükleniyor...",
  "menu.loading": "Yükleniyor...",
  "menu.loadingMore": "Daha fazla yükleniyor...",
  "menu.moreActions": "Daha fazla eylem",
  "menu.noResults": "Sonuç yok",
  "menu.unavailable": "Kullanılamıyor, ayrıntıları görmek için genişletin",
  "notificationbadge.indicatorOnly": "Yeni etkinlik",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "Yükleniyor...",
  "picker.loadingMore": "Daha fazla yükleniyor...",
  "picker.placeholder": "Seçin…",
  "picker.selectedCount": "{count, plural, =0 {Hiçbir öge seçilmedi} one {# öge seçildi} other {# öge seçildi}}",
  "sidepanel.collapse": "Yan paneli daralt",
  "sidepanel.expand": "Yan paneli genişlet",
  "slider.maximum": "Maksimum",
  "slider.minimum": "Minimum",
  "table.cancel": "İptal et",
  "table.drag": "Sürükle",
  "table.editCell": "Hücreyi düzenle",
  "table.loading": "Yükleniyor...",
  "table.loadingMore": "Daha fazla yükleniyor...",
  "table.resizeColumn": "Sütunu yeniden boyutlandır",
  "table.save": "Kaydet",
  "table.sortAscending": "Artan Sıralama",
  "table.sortDescending": "Azalan Sıralama",
  "tag.actions": "Eylemler",
  "tag.hideButtonLabel": "Daha az göster",
  "tag.noTags": "Hiçbiri",
  "tag.showAllButtonLabel": "Tümünü göster ({tagCount, number})",
  "toast.clearAll": "Tümünü temizle",
  "toast.collapse": "Daralt",
  "toast.showAll": "Tümünü göster",
  "treeview.loadingMore": "Daha fazla yükleniyor..."
}
